

















































































































































































































































































































































































































import Tenant from '@/types/Tenant.interface'
import { mapGetters } from 'vuex'
import Vue from 'vue'
export default Vue.extend({
    props: {
        step: {
            type: String, 
            required: true
        },
        dateRangeMode: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        //  User's V2 username (email)
        username: null,
        loading: false,
        contacts: {
            title: "Contacts",
            enabled: false
        },
        customFields: {
            title: "Custom Fields",
            enabled: false
        },
        dateFrom: null as string | null,
        dateTo: null as string | null,
        dateMenuFrom: false,
        dateMenuTo: false,
        //  Extra details for each step - easily add more details here
        stepDetails: {
            step1: [
                "Your email must match your Inbox by MessageDesk account. " +
                "If you do not have an Inbox by MessageDesk account, you can create one at https://inbox.messagedesk.com",
            ],
            step2: [
                "Data migration runs in the background and has no affect on your current MessageDesk Reach account",
                "You will recieve an email notification from no-reply@messagedesk.com when the migration has started and completed for each section"
            ],
            step3: [
                "Phone migration is instant",
            ]
        }
    }),
    computed: {
        ...mapGetters([
            'smsAccount',
            'authIsSupport',
        ]),
        currentTenant(): Tenant {
            return this.$store.getters.tenant
        },
        v2Data(): Record<string, unknown> | null {
            const s = this.$store.getters.settingGet('canMigrateToV2')
            return (s && s.data) ? s.data : null
        },
        lastMigration(): string | null {
            const v = this.v2Data && this.v2Data.lastMigration
            return typeof v === 'string' ? v : null
        },
        isDataMigrationCooldown(): boolean {
            if (this.authIsSupport) return false
            if (!this.lastMigration) return false

            const ms = 24 * 60 * 60 * 1000
            return (Date.now() - new Date(this.lastMigration).getTime()) < ms
        },
        lastMigrationFormatted(): string {
            if (!this.lastMigration) return ''
            try {
                const d = new Date(this.lastMigration)
                const dateStr = d.toLocaleDateString(undefined, {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                })
                const timeStr = d.toLocaleTimeString(undefined, {
                    hour: 'numeric',
                    minute: '2-digit'
                })
                return `${dateStr} ${timeStr}`
            } catch {
                return this.lastMigration
            }
        },
        showDateRange(): boolean {
            return this.authIsSupport
                && this.dateRangeMode
        },
        tenantCreatedDate(): string {
            const raw = this.currentTenant?.created_at
            if (!raw) return ''
            return raw.substring(0, 10)
        },
        todayDate(): string {
            return new Date().toISOString().substring(0, 10)
        },
        dateFromMin(): string {
            return this.tenantCreatedDate
        },
        dateFromMax(): string {
            return this.dateTo || this.todayDate
        },
        dateToMin(): string {
            return this.dateFrom || this.tenantCreatedDate
        },
        dateToMax(): string {
            return this.todayDate
        },
        isDateRangeValid(): boolean {
            if (!this.showDateRange) return true
            return !!this.dateFrom && !!this.dateTo
        }
    },
    methods: {
        convertUrlsToLinks(text: string): string {
            const urlRegex = /(https?:\/\/[^\s]+)/g
            return text.replace(
                urlRegex, 
                '<a href="$1" target="_blank" rel="noopener noreferrer" class="detail-link">$1</a>'
            )
        },
        close(): void {
            return this.$store.dispatch('dialogClose', 'APP')
        },
        async connectToV2(): Promise<void> {
            //  Start spinner to indicate submission is being processed
            this.loading = true

            const payload = {
                'tenantId': this.currentTenant.id,
                'username': this.username
            }

            const response = await this.$store.dispatch('tenantConnectToV2', payload)

            //  If our response is null it means we got a 500 error, i.e user email is incorrect or non-existant
            if (!response) {
                this.loading = false
                return this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'Connection Failed',
                    text: 'Ensure that the email provided is the one used when you created your MessageDesk Version 2 account.'
                })
            }

            //  Reset loading state so button stops spinning
            this.loading = false
            
            //  Let the user know they are connected
            this.$store.commit('appNotificationBarSet', {
                message: 'Accounts Connected',
                type: 'success',
            })

            //  Close our dialog, we submit here so that our callback is activated causing this workflow to be greyed out 
            //  and we'll have the banner above indicate connection was successful
            return this.$emit('submit', response)
        },
        async migrateData(): Promise<void> {
            this.loading = true

            const payload: Record<string, unknown> = {
                'tenantId': this.currentTenant.id,
                'migrateCustomFields': true,
                'migrateContacts': true,
                'migrateOptOuts': true,
                'migrateMessages': true,
                'migrateMessageTemplates': true,
            }

            if (this.showDateRange
                && this.dateFrom
                && this.dateTo
            ) {
                payload.dateFrom = this.dateFrom
                payload.dateTo = this.dateTo
            }
            
            const response = await this.$store.dispatch('tenantMigrateData', payload)

            //  If our response is null it means we got a 500 error, i.e data download failed to start
            if (!response) {
                this.loading = false
                return this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'Data Migration Failed',
                    text: 'Please Contact Support.'
                })
            }

            this.loading = false

            if (response.setting) {
                this.$store.commit('settingsPush', [response.setting])
            }

            this.$store.commit('appNotificationBarSet', {
                message: 'Data Migration Started',
                type: 'success',
            })

            return this.close()
        },
        async transferNumber(): Promise<void> {
            //  Start spinner to indicate submission is being processed
            this.loading = true

            //  Ensure that the customer does have a tenant msisdn first
            if (!this.smsAccount) {
                return this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'Phone Migration Failed',
                    text: 'There is no phone number currently assocaited with this workspace.'
                })
            }

            const payload = {
                'tenantId': this.currentTenant.id,
                'phoneNumber': this.smsAccount.msisdn
            }
            
            const response = await this.$store.dispatch('tenantMigratePhone', payload)

            //  If our response is null it means we got a 500 error, i.e phone migration failed to start
            if (!response) {
                this.loading = false
                return this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'Phone Migration Failed',
                    text: 'Please Contact Support.'
                })
            }

            this.loading = false

            if (response.setting) {
                this.$store.commit('settingsPush', [response.setting])
            }

            this.$store.commit('appNotificationBarSet', {
                message: 'Phone Migration Started',
                type: 'success',
            })

            return this.close()
        }
    }
})
